import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import { SelectMenuProps } from "../../utils/utils";
import { Field, useFormikContext } from "formik";

const FormSelectAdmit = ({
  name,
  data,
  label,
  labelId,
  defaultValue01,
  handleChange,
  ...rest
}: any) => {
  const { touched, errors, values, setFieldValue, initialValues }: any =
    useFormikContext();

  const labelText = typeof label === "string" ? label : label?.name || "";
  const value =
    values[name] !== undefined && values[name] !== null
      ? values[name]
      : initialValues[name] !== undefined && initialValues[name] !== null
      ? initialValues[name]
      : defaultValue01 || ""; // Ensure explicit handling of 0

  const showError = touched[name] && errors[name];

  return (
    <FormControl fullWidth error={showError} {...rest}>
      <InputLabel id={labelId}>{labelText}</InputLabel>
      <Field
        as={Select}
        labelId={labelId}
        value={value}
        displayEmpty
        onChange={(event: any) => {
          setFieldValue(name, event.target.value);
          if (handleChange) {
            handleChange(event.target.value, name);
          }
        }}
        input={
          <OutlinedInput
            label={labelText}
            sx={{
              padding: "10px 12px",
            }}
          />
        }
        MenuProps={SelectMenuProps}
        sx={{
          "& .MuiSelect-select": {
            padding: "10px 12px",
          },
        }}
      >
        <MenuItem value="" disabled sx={{ color: "#A1A1A1 !important" }}>
          {labelText || "Select an option"}
        </MenuItem>

        {data?.map((item: any) => (
          <MenuItem key={item.id} value={item.id}>
            {item.name}
          </MenuItem>
        ))}
      </Field>
      {showError && <FormHelperText>{errors[name]}</FormHelperText>}
    </FormControl>
  );
};

export default FormSelectAdmit;
